<template>
  <Main>
    <v-row>
      <v-col cols="12" sm="8" md="9" class="pr-sm-5">
        <BaseFilter
          v-model="search"
          v-bind="filterProps"
          textPlaceholder="Buscar perfis"
          @search="searchByFilter"
          v-on:keyup="searchByFilterClickEnter"
        />
      </v-col>
      <v-col cols="12" sm="4" md="3" class="mb-5">
        <BaseButton
          class="secondary text-uppercase subtitle-2 font-weight-bold"
          width="100%"
          @click="goToProfileNew()"
        >
          <v-icon class="pr-4 add-icon">fa-plus</v-icon>
          Novo perfil
        </BaseButton>
      </v-col>
      <v-col cols="12">
        <BaseDataTable
          :headers="tableHeaders"
          :items="profiles.items"
          :server-items-length="profiles.total_count"
          no-data-text="Não há perfis cadastrados."
          loading-text="Carregando perfis..."
          :options.sync="filterOptions"
          :loading="listLoading"
          class="profile-table base__datatable"
          @click:row="goToProfileDetails"
        >
          <template v-slot:[`item.nome`]="{ item }">
            <div :class="borderColor(item.status.id)">
              <div class="profile-table__padding">
                {{ item.nome }}
              </div>
            </div>
          </template>
        </BaseDataTable>
      </v-col>
    </v-row>
  </Main>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { defaultFilterOptions } from "@/mixins/PayloadDataTableMixin";

const defaultFilterProps = {
  outlined: true,
  dense: true,
  "background-color": "white",
  class: "filter__icon",
  "append-outer-icon": "fa-search"
};

const tableHeaders = [
  { text: "Perfil", value: "nome", sortable: true },
  { text: "Estrutura de Acesso", value: "estrutura.nome", sortable: false },
  { text: "Status", value: "status.nome", sortable: false }
];

const colorByStatus = {
  ativo: { color: "light-blue" },
  inativo: { color: "pink" }
};

export default {
  name: "ProfileList",
  mixins: [LoadingRequest],
  computed: {
    ...mapState("profile", ["profiles"])
  },
  data: () => ({
    search: "",
    filterProps: defaultFilterProps,
    filterOptions: defaultFilterOptions(),
    tableHeaders,
    listLoading: false
  }),
  watch: {
    filterOptions: {
      handler(value) {
        this.fetchData(this.getPayload(value));
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("profile", ["requestProfileList"]),
    borderColor(status) {
      const { color } = colorByStatus[status];
      return `profile-table__border-${color}`;
    },
    searchByFilter() {
      this.withLoading(
        this.requestProfileList(this.getPayload(this.filterOptions))
      );
    },
    searchByFilterClickEnter(event) {
      if (event.keyCode === 13)
        this.withLoading(
          this.requestProfileList(this.getPayload(this.filterOptions))
        );
    },
    fetchData(payload) {
      this.withLoading(this.requestProfileList(payload));
    },
    goToProfileDetails(item) {
      this.$router.push({
        name: "profile details",
        params: { profileId: item.id }
      });
    },
    goToProfileNew() {
      this.$router.push({ name: "profile new" });
    },
    getPayload(options) {
      const { page, itemsPerPage, sortDesc, sortBy } = options;
      const direction =
        sortBy.length == 1 ? (sortDesc[0] ? "desc" : "asc") : "desc";
      const sort = sortBy.length == 1 ? sortBy[0] : "";
      return {
        page,
        page_size: itemsPerPage,
        sort,
        direction,
        query: this.search,
        somente_ativos: false
      };
    },
    mounted() {
      this.fetchData(this.getPayload(this.filterOptions));
    }
  }
};
</script>

<style lang="sass">
.profile-table
  &__border-light-blue
    border-left: 5px solid #49DCBB
  &__border-pink
    border-left: 5px solid #EF5350
  &__padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
  &.v-data-table.theme--light
    thead tr th
      padding: 8px 8px
    tbody tr td
      padding: 18px 8px
    tbody tr td:first-child
      padding: 2px 0px !important
</style>
